export default __webpack_public_path__ + "6b12ae21b9ebe1d63656a9c488e111f9.jpg";